import { preserveSelection } from 'common/Prose/utils/selection'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { CreateCommentSubmitFn } from 'components/ConvertableCommentTodoForm/Types'
import { schema } from 'prose-core'
import { NodeSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { DocStore } from 'stores/DocStore'

export const createCommentSubmit =
  (
    view: EditorView,
    layerId: string,
    docStore: DocStore,
    richText: boolean,
    uuid: string,
    callback: () => void,
    overridePositionRange?: { from: number; to: number },
  ): CreateCommentSubmitFn =>
  async (comment, mentionedIds, userId) => {
    callback()
    try {
        await docStore.rootStore.comments.create(
            {
              layer_id: layerId,
              comment: comment.trimStart().trimEnd(),
              commentable_id: docStore.articleId,
              commentable_type: 'Article',
              uuid,
            },
            mentionedIds,
            richText,
            undefined,
            userId,
          )
    } catch (error) {
      if (error instanceof Error) showToastMessage(error.message, 'error')
    }

    createCommentMark(view, uuid, overridePositionRange)
  }

const createCommentMark = (
  view: EditorView,
  uuid: string,
  overridePositionRange?: { from: number; to: number },
) => {
  const {
    state,
    state: { tr, selection },
    dispatch,
  } = view
  let { from, to } = overridePositionRange ? overridePositionRange : selection

  // If the selection is a node and has a uuids attr, add the uuid to the node
  // This relies on the fact that paragraphs, headers, lists etc do not have uuids so it applies to their child nodes
  if (selection instanceof NodeSelection && Array.isArray(selection.node.attrs.uuids)) {
    const node = selection.node
    tr.setNodeMarkup(from, undefined, { ...node.attrs, uuids: [...node.attrs.uuids, uuid] })
  } else {
    if (selection.$from.node().type === schema.nodes.smartLink && to - from < selection.$from.node().nodeSize) {
      state.doc.nodesBetween(from, to, (node, pos) => {
        if (node.type === schema.nodes.smartLink) {
          from = pos
          to = pos + node.nodeSize
        }
      })
    }
    preserveSelection(tr, state)
    const mark = state.schema.marks.comment.create({ uuid })
    tr.addMark(from, to, mark)

    tr.setMeta('allowComments', true)
  }
  dispatch(tr)
}
